import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import ADIXtenConfirmationModal from "@NA/Components/ADIXtenConfirmationModal";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import React, { useEffect, useState } from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography from "@insite/mobius/Typography";
import { ResolveThunks, connect, useSelector } from "react-redux";
import ADIXtenIntegrationHandler from "@NA/Handlers/ADIXtenIntegrationHandler";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Link from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import ADIColors from "@NA/Utils/ADIColors";
import AdiXtenIntegrationHelper, {
    IsXtenAllowedUser,
    callToHandler,
    redirectAction,
} from "@NA/Hooks/useAdiXtenIntegrationHelper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import Img from "@insite/mobius/Img";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import CrossIcon from "@NA/Icons/CrossIcon";

export interface adiXtenStyles {
    rightcontent?: InjectableCss;
    rightContentLink?: InjectableCss;
    exportToXtenButton?: ButtonPresentationProps;
    exportToXtenButtonMobile?: ButtonPresentationProps;
    modal?: ModalPresentationProps;
}

export const adiXtenStyles: adiXtenStyles = {
    rightContentLink: {
        css: css`
            font-size: 16px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: ${getColor("primary")};
            :hover {
                text-decoration: underline;
            }
        `,
    },
    exportToXtenButton: {
        variant: "secondary",
        css: css`
            min-width: 226px;
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            justify-content: center;
            border-radius: 4px;
            border: solid 1px ${getColor("secondary")};
            background: ${getColor("common.background")};
            margin-left: 20px;
            svg {
                margin-right: 10px;
                height: 10px;
                width: 13px;
            }
            &:focus {
                outline: none;
            }
            &:hover {
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
            .imgExportSVG {
                max-width: 75px;
                margin-left: 5px;
                margin-bottom: 4px;
            }
            @media only screen and (max-width: 1024px) {
                // display: none;
            }
        `,
    },
    modal: {
        sizeVariant: "small",
        size: 600,
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalContainer: css`
                > div {
                    box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.14);
                    border-radius: 7px;
                }
                button svg {
                    transform: translate(-10px, -6px);
                }
            `,
            modalTitle: css`
                border-bottom: 0;
                span {
                    font-size: 28px;
                    font-weight: bold;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: ${ADIColors.darkBlue1};
                    width: calc(100% - 35px);
                    display: inline-block;
                    text-transform: capitalize;
                }
                button {
                    position: absolute;
                    top: 14px;
                    right: 32px;
                }
            `,
            modalContent: css`
                padding: 0 30px 30px;
            `,
        },
    },
};

const styles = adiXtenStyles;

const mapDispatchToProps = {
    ADIXtenIntegrationHandler,
    loadCurrentCart,
};

interface ADIXtenExportToXtenButtonProps {
    id: string;
    type: string;
    buttonText: string;
    isQuoteExpired?: boolean;
}

type Props = ADIXtenExportToXtenButtonProps & HasHistory & ResolveThunks<typeof mapDispatchToProps>;
const ADIXtenExportToXtenButton: React.FC<Props> = ({
    id,
    type,
    buttonText,
    isQuoteExpired,
    history,
    ADIXtenIntegrationHandler,
    loadCurrentCart,
}: {
    id: string;
    type: string;
    buttonText: string;
    isQuoteExpired?: boolean;
    history: any;
    ADIXtenIntegrationHandler: any;
    loadCurrentCart: any;
}) => {
    const toasterContext = React.useContext(ToasterContext);
    const [listName, setListName] = useState("");
    const [cartPopupMessage, setCartPopupMessage] = useState("");
    const [isADIXtenConfirmationModal, setIsADIXtenConfirmationModal] = useState(false);
    const customerSettings = useSelector((state: ApplicationState) => getSettingsCollection(state).customerSettings);
    const location = useSelector((state: ApplicationState) => getLocation(state));
    const allowedUserRole = customerSettings.allowedUserRole;
    const adiXtenSignupUrl = customerSettings.adiXtenSignupUrl;
    const enableAdiXtenIntegration = customerSettings.enableAdiXtenIntegration;
    const listButtonText = "Export to ";
    const [userAlreadtSignup, SetUserAlreadtSignup] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const { uniqueListName, isUserSignedUp } = enableAdiXtenIntegration ? AdiXtenIntegrationHelper() : {uniqueListName:"", isUserSignedUp: false};
   
    useEffect(() => {
        if (type === "cart" || type === "signup") {
            setListName(uniqueListName);
        }
    }, [type]);
    
    //Export_To_xten_Image
    if (!enableAdiXtenIntegration) {
        return <></>;
    }

    const ADIXtenConfirmationModalOpen = () => {
        setIsADIXtenConfirmationModal(true);
    };

    const closeCancel = () => {
        setIsADIXtenConfirmationModal(false);
    };



    const actionToXtenSignupPage = () => {
        redirectAction(id, type, history, adiXtenSignupUrl);
    };

    const actionToXten = () => {
        if (type === "cart") {
            if (isUserSignedUp) {
                callToHandler(
                    id,
                    type,
                    listName,
                    toasterContext,
                    ADIXtenIntegrationHandler,
                    closeCancel,
                    loadCurrentCart,
                    false,
                    "",
                    SetUserAlreadtSignup,
                );
            } else {
                ADIXtenConfirmationModalOpen();
                //redirectAction(id, type, history, adiXtenSignupUrl);
            }
        } else {
            redirectAction(id, type, history, adiXtenSignupUrl);
        }
    };

    const handleCartButtonAction = (IsTemp: boolean, ListNameInput: string) => {
        if (isUserSignedUp) {
            callToHandler(
                id,
                type,
                listName,
                toasterContext,
                ADIXtenIntegrationHandler,
                closeCancel,
                loadCurrentCart,
                IsTemp,
                ListNameInput,
                SetUserAlreadtSignup,
            );
        } else {
            ADIXtenConfirmationModalOpen();
            //redirectAction(id, type, history, adiXtenSignupUrl);
        }
    };

    //Handle Export To Xten from Cart Page
    const handleExportToXtenCart = () => {
        setListName(uniqueListName);
        if (isUserSignedUp) {
            setCartPopupMessage(translate(`The cart items will be moved to "${uniqueListName}" and exported to XTEN`));
            ADIXtenConfirmationModalOpen();
        } else {
            actionToXten();
        }
    };

    //Handle Export To Xten for Order history detail, mylist, my quotes and my account page
    const handleExportToXten = () => {
        if (isUserSignedUp) {
            if (type?.toLowerCase() != null && type?.toLowerCase() === "myquote" && isQuoteExpired) {
                // toasterContext.addToast({
                //     body: translate("Expired quotes can not be exported"),
                //     messageType: "success",
                //   });
                setIsOpenModal(true);
            } else {
                setIsOpenModal(false);
                callToHandler(
                    id,
                    type,
                    listName,
                    toasterContext,
                    ADIXtenIntegrationHandler,
                    closeCancel,
                    loadCurrentCart,
                    false,
                    "",
                    SetUserAlreadtSignup,
                );
            }
        } else {
            ADIXtenConfirmationModalOpen();
        }
    };

    const modalCloseHandler = () => {
        setIsOpenModal(false);
    };

    return (
        <>
            {IsXtenAllowedUser(allowedUserRole) && (
                <StyledWrapper className="btnStyleWrapper">
                    {type === "cart" ? (
                        <Typography>
                            <Button onClick={handleExportToXtenCart} {...styles.exportToXtenButton}>
                                {listButtonText}
                                <Img
                                    className="imgExportSVG"
                                    altText="Export To XTEN"
                                    src="/userfiles/Export_To_xten_Image.png"
                                />
                            </Button>
                            <ADIXtenConfirmationModal
                                isOpen={isADIXtenConfirmationModal}
                                handleClose={closeCancel}
                                actionToXten={actionToXten}
                                isCart={true}
                                listName={listName}
                                actionToXtenSignupPage={actionToXtenSignupPage}
                                isUserSignedUp={isUserSignedUp}
                                handleCartButtonAction={handleCartButtonAction}
                            />
                        </Typography>
                    ) : (
                        <Typography>
                            {type === "xdraw" || type === "xdoc" ? (
                                <li>
                                    <Link {...styles.rightContentLink} onClick={handleExportToXten}>
                                        {buttonText}
                                    </Link>
                                </li>
                            ) : (
                                <Button
                                    onClick={handleExportToXten}
                                    className="btnExportWrapper"
                                    {...styles.exportToXtenButton}
                                >
                                    {listButtonText}
                                    <Img
                                        className="imgExportSVG"
                                        altText="Export To XTEN"
                                        src="/userfiles/Export_To_xten_Image.png"
                                    />
                                </Button>
                            )}

                            <ADIXtenConfirmationModal
                                isOpen={isADIXtenConfirmationModal}
                                handleClose={closeCancel}
                                actionToXten={actionToXten}
                                isCart={false}
                                listName=""
                                actionToXtenSignupPage={actionToXtenSignupPage}
                                isUserSignedUp={isUserSignedUp}
                                handleCartButtonAction={handleCartButtonAction}
                            />
                        </Typography>
                    )}
                </StyledWrapper>
            )}
            <StyledWrapper>
                <Modal
                    headline={<Typography>{translate("")}</Typography>}
                    {...styles.modal}
                    isOpen={isOpenModal}
                    handleClose={modalCloseHandler}
                >
                    <Typography as="p" className="modalContainer">
                        <Typography as="span" className="modalText">
                            {translate("You can only export a quote that has not expired.")}
                        </Typography>
                    </Typography>
                </Modal>
            </StyledWrapper>
        </>
    );
};
export default connect(null, mapDispatchToProps)(withHistory(ADIXtenExportToXtenButton));
